import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { eContactSection, eSearchContactType } from '@hub/generated/enums';
import { ContactSelectorDto, FilterCollection, FilterPickerContact, FilterValue, FilterValueCollection, SearchContactsOptions } from '@hub/generated/models';
import { SearchController } from '@hub/generated/services';
import { Functions } from '@hub/common/Functions';

@Component({
  selector: 'f-filterPickerContact',
  templateUrl: './filterPickerContact.component.html',
  styleUrls: ['./filterPickerContact.component.scss']
})
export class FilterPickerContactComponent implements OnInit {
  // Constructors
  constructor (private controller: SearchController) {
  }

  // Properties
  @Input()
  public filter: FilterPickerContact;
  
  private _filterCollection: FilterCollection;

  @Input()  set filterCollection(f: FilterCollection) {
      this._filterCollection = f;
      this.value = this.getValue();      
  }
  get filterCollection() {
      return this._filterCollection;
  }

  @Input()
  public inline: boolean = false;

  @Output()
  public ondataChange: EventEmitter<FilterValueCollection> = new EventEmitter<FilterValueCollection>();

  public value: ContactSelectorDto;
  public columnName: string;
  public suggestions: ContactSelectorDto[];

  public ngOnInit() {
    this.columnName = this.filter.ColumnName;
    this.value = this.getValue();
  }

  search(event) {
    
    let searchParameters: SearchContactsOptions = Functions.GetInstanceSearchContactsOptions(event.query);
    searchParameters.Types = this.filter.Types,
    
    this.controller.SearchContacts(searchParameters).subscribe(data => {
        this.suggestions = data;
    });
  }

  public onChange(event) {
    let result: FilterValueCollection = new FilterValueCollection();
    result.ColumnName = this.columnName;
    if (this.value) {
      let value: FilterValue = { Key: this.value.Id, Value: this.value.FullName, EntityType: null };
      result.List = [ value ];
    } else
      result.List = [];

    this.ondataChange.emit(result);
  }

  public onClear(event) {
    let result: FilterValueCollection = new FilterValueCollection();
    result.ColumnName = this.columnName;
    result.List = undefined;
    this.ondataChange.emit(result);
  }

  private getValue(): ContactSelectorDto
  {
    if (!!this.filterCollection && !!this.filterCollection.List) {
      let values = this.filterCollection.List.filter((item) => item.ColumnName == this.columnName)[0];
      if (!!values && !!values.List && !!values.List.length) {
        let value = values.List[0]
        return { Id: value.Key, FullName: value.Value, EntityType: null };
      }
    }

    return null;
  }
}
